import type { ConstValues } from '@openx/types/helpers';

// Mirrors the GraphQL schema proposed in EXCH-18569 (not yet implemented server-side —
// backend PR https://github.com/openx/mgt-axiom-server/pull/272 is still a stub-backed draft).
// Swap for the generated `@openx/types/gqlTypes` equivalents once that query is live and codegen can reach it.

export const DealAdCategoryProposalStatus = {
  Pending: 'pending',
  Accepted: 'accepted',
  Rejected: 'rejected',
} as const;
export type DealAdCategoryProposalStatus = ConstValues<typeof DealAdCategoryProposalStatus>;

export type DealAdCategoryProposalAccount = {
  name?: string | null;
};

export type DealAdCategoryProposalDeal = {
  dealId: string;
  name?: string | null;
  account?: DealAdCategoryProposalAccount | null;
};

export interface DealAdCategoryProposal {
  id: string;
  revision: number;
  dealId: string;
  proposedAdCategory: string;
  status: DealAdCategoryProposalStatus;
  categoryBids: number;
  categoryBidShare: number;
  classifiedBids: number;
  windowStart: string;
  windowEnd: string;
  proposedDate: string;
  decisionDate: string | null;
  deal?: DealAdCategoryProposalDeal | null;
}
